import React from "react";
import { ArrowDown, ArrowUp, Minus } from "lucide-react";

/**
 * Small diff chip shown next to an AGA field label when a previous value
 * exists for the same field. For numeric fields shows Δ + arrow; for
 * strings shows "era: X" only when the value differs.
 */
export default function FieldDeltaChip({ current, previous }) {
    if (previous === undefined || previous === null || previous === "") return null;
    const nowEmpty = current === undefined || current === null || current === "";
    if (nowEmpty && (previous || previous === 0)) {
        return (
            <span
                className="ml-2 inline-flex items-center gap-1 text-[10px] px-1.5 py-0.5 rounded-full bg-[#F4EFE6] text-brand-secondary font-medium"
                title={`Valor anterior: ${previous}`}
            >
                era: {String(previous).length > 20 ? String(previous).slice(0, 18) + "…" : String(previous)}
            </span>
        );
    }

    // Numeric comparison
    const numA = Number(current);
    const numB = Number(previous);
    const bothNumeric = Number.isFinite(numA) && Number.isFinite(numB);

    if (bothNumeric) {
        const diff = numA - numB;
        if (diff === 0) {
            return (
                <span
                    className="ml-2 inline-flex items-center gap-1 text-[10px] px-1.5 py-0.5 rounded-full bg-[#F4EFE6] text-brand-secondary font-medium"
                    title={`Igual à consulta anterior (${previous})`}
                >
                    <Minus size={10} /> igual
                </span>
            );
        }
        const isDown = diff < 0;
        const abs = Math.abs(diff);
        const rounded = Number.isInteger(abs) ? abs : Math.round(abs * 100) / 100;
        return (
            <span
                className={`ml-2 inline-flex items-center gap-1 text-[10px] px-1.5 py-0.5 rounded-full font-medium ${
                    isDown ? "bg-[#FDECEA] text-[#8B2E1F]" : "bg-[#E5EFE0] text-[#315B3A]"
                }`}
                title={`Consulta anterior: ${previous}`}
            >
                {isDown ? <ArrowDown size={10} /> : <ArrowUp size={10} />} {rounded}
                <span className="opacity-60 ml-0.5">(era {previous})</span>
            </span>
        );
    }

    // Non-numeric: only show badge if value changed
    if (String(current || "") === String(previous || "")) return null;
    const prev = String(previous);
    const short = prev.length > 24 ? prev.slice(0, 22) + "…" : prev;
    return (
        <span
            className="ml-2 inline-flex items-center gap-1 text-[10px] px-1.5 py-0.5 rounded-full bg-[#F4EFE6] text-brand-secondary font-medium"
            title={`Valor anterior: ${previous}`}
        >
            era: {short}
        </span>
    );
}
